@let info = banner();
@if (info) {
    <div class="past-due-banner animated fadeIn" role="alert">
        <!-- Icon and text share a row of their own so a narrow container can drop
             the CTA to the next line without orphaning the icon (DEV-10988). -->
        <div class="past-due-banner__row">
            <div class="past-due-banner__icon" aria-hidden="true">!</div>

            <div class="past-due-banner__text">
                <strong>Past-due {{ info.balance | currency:'USD':'symbol':'1.2-2' }}</strong>
                @if (info.daysUntil !== null && info.daysUntil !== undefined) {
                    @if (info.daysUntil > 0) {
                        <span class="past-due-banner__sub">
                            Suspended in {{ info.daysUntil }}d
                        </span>
                    } @else {
                        <span class="past-due-banner__sub past-due-banner__sub--urgent">
                            Suspension imminent
                        </span>
                    }
                }
            </div>
        </div>

        <button type="button"
                class="btn btn-sm btn-primary past-due-banner__cta"
                (click)="onCta()">
            Update payment
        </button>
    </div>
}
